import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class FrameAncestors extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'frame-ancestors';
    }
    getDirectiveType() {
        return DirectiveType.Navigation;
    }
    getMinimumCspVersion() {
        return 2;
    }
}
